"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _file = require("FileManagerCore/utils/file");

var _default = _file.getIsFileManagerUrl;
exports.default = _default;
module.exports = exports.default;